// extracted by mini-css-extract-plugin
module.exports = {"saleDetailsContainer":"SaleDetails_saleDetailsContainer__3wuiB","type":"SaleDetails_type__2Inz9","label":"SaleDetails_label__20gPa","value":"SaleDetails_value__11_ds"};